module.exports = __webpack_public_path__ + "img/Foto_DAB_-_Daily_Social.f3a90dbd.png";